import { AppMenuItems } from "../../infrastructure/enum/Common";

export enum IcPages {
  LOGOUT = "Logout",
  NEED_HELP = "Need Help",
  TERMS_OF_USE = "Terms of Use",
}

export enum IframeMessageType {
  IC_APP_LOADED = "IC_APP_LOADED",
  IMPERSONATION_CHANGE = "IMPERSONATION_CHANGE",
  LOCATION_CHANGE = "LOCATION_CHANGE",
  LOCATION_POPSTATE = "LOCATION_POPSTATE",
  LOGOUT = "LOGOUT",
  REQUEST_AUTH_CACHE = "REQUEST_AUTH_CACHE",
  AUTH_CACHE_RESPONSE = "AUTH_CACHE_RESPONSE",
}

export type Pages = AppMenuItems | IcPages;
